import React from 'react';
import {Card, CardActionArea, CardContent, CardMedia, Chip, Tooltip, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {EXAMPLES_ROUTE} from '../../utils/consts';
import RequestAppointmentCounter from "../RequestAppointmentCounter";
import DragHandleIcon from '@mui/icons-material/DragHandle';

const API_URL = process.env.REACT_APP_API_URL || window.API_URL;

const ServiceItem = ({service}) => {
    const navigate = useNavigate();
    const content = service?.description ? service.description.substring(0, 200) + "..." : "[Без описания]";

    return (
        <Card
            sx={{
                width: 500,
                minWidth: 300,
                border: 1,
                borderColor: "grey.300",
                borderRadius: 1,
                position: 'relative',
            }}
            elevation={0}
        >
            <Tooltip title="Зажмите и перетащите, чтобы изменить порядок услуг в боте" arrow>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: 100,
                    width: '48px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'grab',
                }}>
                    <DragHandleIcon sx={{
                        opacity: 0.5,
                    }}/>
                </div>
            </Tooltip>
            <CardActionArea
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start', // Align to top for multi-paragraph content
                    minHeight: 150, // Ensure enough vertical space
                    width: '100%',
                }}
                onClick={() => navigate(EXAMPLES_ROUTE + "/" + service.id)}
            >
                <CardMedia
                    component="img"
                    image={API_URL + "/static/" + service.image}
                    sx={{
                        width: '150px',
                        height: '150px',
                        objectFit: 'cover',
                        borderRadius: 1,
                        mr: 3,
                        flexShrink: 0,
                    }}
                />
                <CardContent sx={{display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%'}}>
                    <Typography variant="h5" sx={{fontWeight: 'medium'}}>
                        {service.name}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                            // whiteSpace: 'pre-line', // Preserve paragraph breaks
                            maxHeight: 100, // Limit height to prevent overflow
                            overflowY: 'auto', // Scroll if description is too long
                            mb: 1,
                        }}
                    >
                        {content}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Автор: {service.user?.internalName || service.user?.name || service.authorInternalNameSnapshot || service.authorNameSnapshot || "Неизвестно"}
                    </Typography>
                    <Tooltip 
                        title={
                            <>
                                {service.categories?.length > 0 && <div><b>Категории, в которых отображается данная услуга:</b> {service.categories.map(c => c.name).join(', ')}</div>}
                                {service.branches?.length > 0 && <div><b>Филиалы, в которых отображается данная услуга:</b> {service.branches.map(b => b.name).join(', ')}</div>}
                                {service.doctors?.length > 0 && <div><b>Врачи, которые отображаются в данной услуге:</b> {service.doctors.map(d => d.name).join(', ')}</div>}
                            </>
                        }
                        arrow
                        placement="top"
                    >
                        <Typography 
                            variant='body2' 
                            component={'div'} 
                            color='templateText.secondary'
                            sx={{ 
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                minHeight: '66px',
                                cursor: 'pointer'
                            }}
                        >
                            {service.categories?.map((category) => (
                                <Chip
                                    size='small'
                                    key={category.id}
                                    label={category.name}
                                    sx={{
                                        mr: 0.5,
                                        mb: 0.5,
                                        bgcolor: '#E91E63',
                                        color: 'white',
                                        fontWeight: 'bold'
                                    }}
                                />
                            ))}
                            {service.branches?.map((branch) => (
                                <Chip
                                    size='small'
                                    color='info'
                                    key={branch.name}
                                    label={branch.name}
                                    sx={{mr: 0.5, mb: 0.5}}
                                />
                            ))}
                            {service.doctors?.map((doctor) => (
                                <Chip
                                    size='small'
                                    color='success'
                                    key={doctor.id}
                                    label={doctor.name}
                                    sx={{mr: 0.5, mb: 0.5}}
                                />
                            ))}
                        </Typography>
                    </Tooltip>
                    <RequestAppointmentCounter count={service?.requestAppointmentCount}/>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default ServiceItem;
